export const State = {
    Enabled: 1,
    Paused: 2,
    Archived: 3,
}
export const stateOptions = {
    [State.Enabled]: { intent: 'success', text: 'Enabled' },
    [State.Paused]: { text: 'Paused' },
    [State.Archived]: { intent: 'warning', text: 'Archived' },

    [`${State.Enabled},${State.Enabled}`]: { intent: 'success', text: 'Enabled' },
    [`${State.Paused},${State.Enabled}`]: { intent: 'split-default-success', text: 'Paused' },
    [`${State.Archived},${State.Enabled}`]: { intent: 'split-warning-success', text: 'Archived' },
}

export enum UpdateReportAdTypesE {
    Campaigns = 1,
    AdGroups = 2,
    ProductAds = 3,
    Keywords = 4,
    Targets = 5,
    CampaignNegativeKeywords = 6,
    NegativeKeywords = 7,
    NegativeTargets = 8,
    KeywordsAndTargets = 999,
    SearchTerms = 20,
}

export enum NumericalChangeActionsE {
    Set = 'set-to-$',
    IncreasePercent = 'increase-%',
    DecreasePercent = 'decrease-%',
    IncreaseDelta = 'increase-$',
    DecreaseDelta = 'decrease-$',
}

export enum FrequencyE {
    AfterEveryDataSync = 1,
    OncePerDay = 2,
    Manually = 3,
    OnCertainDays = 4,
    AtACertainTime = 5,
    OnCertainDates = 6,
}
